__turbopack_context__.v({
  "blockQuote": "wGMQ2q_blockQuote",
  "cite": "wGMQ2q_cite",
  "citeLink": "wGMQ2q_citeLink",
  "root": "wGMQ2q_root",
});
